import '../shared/disable-number-input-wheel.js';
import { initMemberNav } from './member-nav.js';
import { initKioskIndexPage } from '../kiosk-index-page.js';

initKioskIndexPage(initMemberNav(jQuery));
